<div class="dialog-container">
  <div class="dialog-description">آیا از انتشار پست منصرف شده‌اید؟</div>
  <div class="dialog-button" (click)="remove()">بله</div>
  <div class="dialog-button" (click)="cancel()">خیر</div>
</div>
